import { render, staticRenderFns } from "./RailwayData.vue?vue&type=template&id=e296f404&scoped=true&"
import script from "./RailwayData.vue?vue&type=script&lang=js&"
export * from "./RailwayData.vue?vue&type=script&lang=js&"
import style0 from "./RailwayData.vue?vue&type=style&index=0&id=e296f404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e296f404",
  null
  
)

export default component.exports